module.exports = __webpack_public_path__ + "fonts/Spectral-Regular.cd863c5.ttf";